export default class TabOptions {
  preventTabChange = true;
  preventBack = true;
  preventRouteLeave = true;
  keepUpdates = false;
  hidden = false;
  disabled = false;
  constructor(initialModel, additionalProps) {
    this.initialModel = initialModel ?? {};
    Object.assign(this, additionalProps);
  }
}
